let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("af8vx")).then(() => parcelRequire('1V30C'));